import React from 'react'
import Hearder from './Hearder';
import SideBar from './SideBar';


const Layout = () => {
  return (
   <>  
       <Hearder/>
      <SideBar /> 
      
   </>
  )
}

export default Layout;
